import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { reducers } from './reducers';

// Create combined reducer
const appReducer = combineReducers(reducers);

// Root reducer that handles global reset
const rootReducer = (state: any, action: any) => {
  // When RESET_STORE action is dispatched, reset all state
  if (action.type === 'RESET_STORE') {
    state = undefined;
  }
  return appReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,

  // I add this to help with non-serializable values in redux state when creating kyc slices
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [
          'kycInformation/setKycDirectorOneSlider',
          'kycInformation/setKycDirectorTwoSlider',
          'hireDispatcherSlice/setHireDispatcherSlider',
        ],
        // Ignore these paths in the state
        ignoredPaths: [
          'kycInformationData.kycDirectorOne.directorOneId',
          'kycInformationData.kycDirectorTwo.directorTwoId',
          'hireDispatcher.hireDispatcherData.profilePicture',
        ],
      },
    }),
});

// Global action creator for resetting the store
export const resetStore = () => ({ type: 'RESET_STORE' });

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDisPatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export default store;
